/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_Retention_SessionInputs */

const tr_cerez_retention_session = /** @type {(inputs: Cerez_Retention_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarayıcı oturumu`)
};

const en_cerez_retention_session = /** @type {(inputs: Cerez_Retention_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser session`)
};

const de_cerez_retention_session = /** @type {(inputs: Cerez_Retention_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser-Sitzung`)
};

const ru_cerez_retention_session = /** @type {(inputs: Cerez_Retention_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сессия браузера`)
};

/**
* | output |
* | --- |
* | "Browser session" |
*
* @param {Cerez_Retention_SessionInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_retention_session = /** @type {((inputs?: Cerez_Retention_SessionInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_Retention_SessionInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_retention_session(inputs)
	if (locale === "de") return de_cerez_retention_session(inputs)
	if (locale === "ru") return ru_cerez_retention_session(inputs)
	return tr_cerez_retention_session(inputs)
});